"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasSpecialization = exports.getSpecializations = exports.professionSpecializationsRecord = void 0;
exports.isNoneSpecialization = isNoneSpecialization;
exports.isGenericSpecialization = isGenericSpecialization;
exports.findNoneSpecializationByProfession = findNoneSpecializationByProfession;
exports.findNoneSpecializationByProfessionOrThrow = findNoneSpecializationByProfessionOrThrow;
exports.findGenericSpecializationByProfession = findGenericSpecializationByProfession;
exports.findGenericSpecializationByProfessionOrThrow = findGenericSpecializationByProfessionOrThrow;
const enums_1 = require("@bemlo/enums");
const market_profession_specialization_hierarchy_1 = __importDefault(require("./market-profession-specialization-hierarchy"));
// TODO: link this to SPECIALIZATIONS array
const professionNoneSpecializationRecord = {
    [enums_1.Profession.DOCTOR]: enums_1.Specialization.DOCTOR_NONE,
    [enums_1.Profession.NURSE]: enums_1.Specialization.NURSE_NONE,
};
// TODO: link this to SPECIALIZATIONS array
const professionGenericSpecializationRecord = {
    [enums_1.Profession.DOCTOR]: enums_1.Specialization.DOCTOR_GENERIC_SPECIALIZATION,
    [enums_1.Profession.NURSE]: enums_1.Specialization.NURSE_GENERIC_SPECIALIZATION,
};
exports.professionSpecializationsRecord = {
    [enums_1.Profession.DOCTOR]: Object.values(enums_1.DoctorSpecialization),
    [enums_1.Profession.NURSE]: Object.values(enums_1.NurseSpecialization),
};
const noneSpecializations = new Set(Object.values(professionNoneSpecializationRecord));
const genericSpecializations = new Set(Object.values(professionGenericSpecializationRecord));
function isNoneSpecialization(specialization) {
    return noneSpecializations.has(specialization);
}
function isGenericSpecialization(specialization) {
    return genericSpecializations.has(specialization);
}
function findNoneSpecializationByProfession(profession) {
    return professionNoneSpecializationRecord[profession];
}
function findNoneSpecializationByProfessionOrThrow(profession) {
    const specialization = professionNoneSpecializationRecord[profession];
    if (specialization) {
        return specialization;
    }
    throw new Error(`no NONE specialization for profession "${profession}"`);
}
function findGenericSpecializationByProfession(profession) {
    return professionGenericSpecializationRecord[profession];
}
function findGenericSpecializationByProfessionOrThrow(profession) {
    const specialization = professionGenericSpecializationRecord[profession];
    if (specialization) {
        return specialization;
    }
    throw new Error(`no GENERIC_SPECIALIZATION specialization for profession "${profession}"`);
}
const getSpecializations = ({ market, professions, includeNone, includeGeneric, }) => {
    let specializations = market_profession_specialization_hierarchy_1.default;
    if (market) {
        specializations = specializations.filter((specialization) => specialization.markets.includes(market));
    }
    if (professions) {
        specializations = specializations.filter(({ profession }) => professions.includes(profession));
    }
    if (!includeNone) {
        specializations = specializations.filter(({ isNone }) => !isNone);
    }
    if (!includeGeneric) {
        specializations = specializations.filter(({ isGeneric }) => !isGeneric);
    }
    return specializations.map(({ specialization }) => specialization);
};
exports.getSpecializations = getSpecializations;
const hasSpecialization = (profession) => {
    return market_profession_specialization_hierarchy_1.default.some((specializationItem) => specializationItem.profession === profession);
};
exports.hasSpecialization = hasSpecialization;
